import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { AnnouncementElementDataType } from '@/components/sections/builder/elements/header/announcement/types';
import InputLink from '@/components/sections/builder/settings/input-link';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import clsx from 'clsx';
import { RectangleEllipsis } from 'lucide-react';
import Link from 'next/link';
import { shallow } from 'zustand/shallow';

type ElementDataType = {
  name: string;
  link: string;
  label: string;
};

const defaultData: ElementDataType = {
  name: 'Announcement Item',
  link: '',
  label:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vestibulum laoreet ex a imperdiet. Integer at convallis metus. Donec ultricies ac leo ac auctor.',
};

export const ElementContent = ({ element }: ElementProps) => {
  const data = (element.data || defaultData) as ElementDataType;

  const parentData = (element.parentData || {}) as AnnouncementElementDataType;
  const isExternal = data.link?.includes('http');

  return (
    <Link
      href={isExternal ? data.link || '#' : `/${(data.link || '').replace(/^\/+/, '')}`}
      className='cursor-pointer'
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
    >
      <p
        className={clsx(
          'text-center md:line-clamp-1',
          parentData.contentAlign === 'left' && 'lg:text-left',
          parentData.contentAlign === 'center' && 'text-center',
          parentData.contentAlign === 'right' && 'lg:text-right'
        )}
        dangerouslySetInnerHTML={{ __html: data.label }}
      />
    </Link>
  );
};

export const ElementPreviewIcon = RectangleEllipsis;

export function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setChildData: state.setChildData,
    }),
    shallow
  );

  const data = (element.data || defaultData) as ElementDataType;

  return (
    <div>
      <div className='mb-4 font-bold'>Label</div>
      <TextEditorMinimal
        onChange={(val) => {
          builder.setChildData(element.parentId as string, element.id, { label: val });
        }}
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        output='html'
        value={data.label}
        className='mb-2 w-full max-w-64'
        editable
        placeholder='Button Title'
      />
      <div className='mb-4 mt-4 font-bold'>Link</div>
      <InputLink
        name='url_path'
        placeholder='Search or enter a link'
        onChange={(value) => {
          builder.setChildData(element.parentId as string, element.id, {
            link: value,
          });
        }}
        value={data.link as string}
      />
    </div>
  );
}

const AnnouncementItem = {
  type: 'announcement_item',
  group: 'announcement',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
};

export default AnnouncementItem;
